/*
  This file should use ES5 module.exports syntax because it is used also while starting the app
*/
module.exports = {
  primaryColor: '#e43f3f',
  fontSizeBase: '16px',
};
